import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative min-h-screen flex items-center pt-24 pb-12 overflow-hidden" data-id="element-146">
      <div className="container mx-auto px-6 md:px-12" data-id="element-147">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center" data-id="element-148">
          <div className="lg:col-span-7 z-10" data-id="element-149">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            ease: [0.21, 0.47, 0.32, 0.98]
          }} data-id="element-150">
              <span className="inline-flex items-center gap-2 py-1.5 px-3 rounded-full border border-border text-xs font-medium text-accent mb-6 uppercase tracking-wider" data-id="element-151">
                <span className="relative flex h-2 w-2" data-id="element-152">
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-accent" data-id="element-153"></span>
                </span>
                Engineering Leadership Advisor · Co-founder & CEO, Waydev
              </span>

              <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.08] tracking-tight mb-6 text-balance" data-id="element-154">
                Turning engineering into a{' '}
                <em className="text-accent not-italic font-medium" data-id="element-155">
                  measurable competitive advantage.
                </em>
              </h1>

              <p className="text-lg md:text-xl text-secondary max-w-2xl mb-10 leading-relaxed text-balance" data-id="element-156">
                I partner with CTOs and VPEs at scale-ups and Fortune 500s
                (Amex, Caterpillar, PwC) to optimize developer productivity,
                align technical execution with business strategy, and scale
                high-performing engineering organizations.
              </p>

              <div className="flex flex-col sm:flex-row gap-4" data-id="element-157">
                <Button size="lg" onClick={() => window.open('https://calendly.com/alexcircei/advising', '_blank')} className="group" data-id="element-158">
                  Book an advisory call
                  <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-159" />
                </Button>
                <Button size="lg" variant="outline" onClick={() => scrollTo('work')} data-id="element-160">
                  See case studies
                </Button>
              </div>

              <p className="mt-8 text-sm text-muted flex items-center gap-2" data-id="element-161">
                Selectively partnering with a small number of engineering orgs
                each quarter.
              </p>
            </motion.div>
          </div>

          <div className="lg:col-span-5 relative" data-id="element-162">
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 1,
            delay: 0.2,
            ease: [0.21, 0.47, 0.32, 0.98]
          }} className="relative aspect-[4/5] md:aspect-[3/4] lg:aspect-[4/5] max-w-md mx-auto lg:ml-auto rounded-2xl overflow-hidden border border-border/50" data-id="element-163">
              <div className="absolute inset-0 bg-surface/20 mix-blend-overlay z-10" data-id="element-164" />
              <img src="https://cdn.magicpatterns.com/uploads/9oCdhNqN5xVM3pH6rrbHwo/pasted-image.jpg" alt="Alex Circei" className="w-full h-full object-cover" data-id="element-165" />
              <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-base via-base/80 to-transparent z-20" data-id="element-166">
                <p className="font-medium text-primary" data-id="element-167">Alex Circei</p>
                <p className="text-sm text-secondary" data-id="element-168">
                  Co-founder & CEO, Waydev
                </p>
              </div>
            </motion.div>

            {/* Decorative elements */}
            <div className="absolute -top-12 -right-12 w-64 h-64 bg-accent/5 rounded-full blur-3xl -z-10" data-id="element-169" />
            <div className="absolute -bottom-12 -left-12 w-64 h-64 bg-surface rounded-full blur-3xl -z-10" data-id="element-170" />
          </div>
        </div>
      </div>
    </section>;
}